// React
import React from 'react';

//Material UI
import {
    Typography,
    withStyles,
    Grid, Box
} from '@material-ui/core';


//Font Awesome Icons
import {faTimes, faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";



const styles = theme => ({

    titleBoxOpen:{
        backgroundColor: '#90d3ff',
        color:theme.palette.primary.main,
        paddingLeft:35,
        paddingRight:35,
        [theme.breakpoints.down("sm")]: {
            paddingLeft:15,
            paddingRight:15,
        }
    },
    titleBoxClosed:{
        backgroundColor: '#90d3ff',
        paddingLeft:35,
        paddingRight:35,
        [theme.breakpoints.down("sm")]: {
            paddingLeft:15,
            paddingRight:15,
        }
    },
    titleBoxText:{
        fontSize:30,
        fontWeight:'bold',
        color:theme.palette.primary.main,
        lineHeight:3,
        [theme.breakpoints.down("sm")]: {
            fontSize: 24,
            lineHeight:1.2,
            paddingTop:10,
            paddingBottom:10
        },
    },
    titleBoxTextClosed:{
        fontSize:30,
        fontWeight:'bold',
        color:theme.palette.primary.main,
        lineHeight:3,
        [theme.breakpoints.down("sm")]: {
            fontSize: 24,
            lineHeight:1.2,
            paddingTop:10,
            paddingBottom:10
        },
    },
    titleBoxIcon:{
        fontSize:24,
        fontWeight:'bold',
        lineHeight:'95px',
        color:theme.palette.primary.main,
        [theme.breakpoints.down("sm")]: {
            fontSize:18,
        }
    },
    titleBoxIconClosed:{
        fontSize:24,
        fontWeight:'bold',
        lineHeight:'95px',
        color:theme.palette.primary.main,
        [theme.breakpoints.down("sm")]: {
            fontSize:18,
        }
    },
    expandableBody:{
        padding:40,
        backgroundColor: '#f6f6f6',
        [theme.breakpoints.down("sm")]: {
            padding:20,
        }
    },
    panelOuter:{
        marginTop:20,
        marginBottom:30,
    }
});



class Collapsable extends React.Component {




    constructor(props){
        super(props);
        this.state = {
            open: false
        }
        this.togglePanel = this.togglePanel.bind(this);
    }

    togglePanel(e){
        this.setState({open: !this.state.open})
    }

    componentDidUpdate(){

    }

    render() {

        const { classes } = this.props;
        return (
            <div className={classes.panelOuter}>
                <div onClick={(e)=>this.togglePanel(e)} className={this.state.open ? classes.titleBoxOpen : classes.titleBoxClosed}>
                    <Grid container>
                        <Grid item xs={11} sm>
                            <Typography className={this.state.open ? classes.titleBoxTextClosed : classes.titleBoxText} width="100%">{this.props.title}</Typography>
                        </Grid>
                        <Grid item>
                            <Box display="flex" alignItems="center" height={'100%'}>
                                <Box>
                                    {this.state.open ?
                                        <FontAwesomeIcon className={classes.titleBoxIcon} icon={faTimes} />
                                        :
                                        <FontAwesomeIcon className={classes.titleBoxIconClosed} icon={faPlus} />
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </div>
                {this.state.open ? (
                    <div className={classes.expandableBody}>
                        {this.props.children}
                    </div>
                ) : null}
            </div>);
    }
}

export default withStyles(styles, { withTheme: true })(Collapsable);